<div class="row justify-content-center register">
  <div class="col-12">
    <h2>Registrarse</h2>
    <form
      [formGroup]="registerPersonForm"
      class="center">
      <small>Ingresá tus datos para crear tu cuenta</small>
      <div class="row">
        <div class="col-12 col-md-6 noPaddingLeft">
          <mat-form-field class="full-width">
            <mat-label>Nombre</mat-label>
            <input
              matInput
              formControlName="name"
              type="text"
              name="given-name"
              autocomplete="given-name" />
            <mat-error *ngIf="registerPersonForm.controls['name'].errors?.required"
              >Campo requerido</mat-error
            >
          </mat-form-field>
        </div>
        <div class="col-12 col-md-6 noPaddingRight">
          <mat-form-field class="full-width">
            <mat-label>Apellido</mat-label>
            <input
              matInput
              formControlName="lastname"
              type="text"
              name="family-name"
              autocomplete="family-name" />
            <mat-error *ngIf="registerPersonForm.controls['lastname'].errors?.required"
              >Campo requerido</mat-error
            >
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-12 noPaddingLeft noPaddingRight">
          <mat-form-field class="full-width">
            <mat-label>Email</mat-label>
            <input
              matInput
              formControlName="email"
              type="email"
              name="email"
              autocomplete="email" />
            <mat-error *ngIf="registerPersonForm.controls['email'].errors?.required"
              >Campo requerido</mat-error
            >
            <mat-error *ngIf="registerPersonForm.controls['email'].errors?.pattern"
              >Usá un formato válido</mat-error
            >
            <mat-error *ngIf="registerPersonForm.controls['email'].errors?.valMail"
              >El email ingresado ya es un usuario</mat-error
            >
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-12 noPaddingLeft noPaddingRight">
          <mat-label class="title-label">Teléfono de contacto</mat-label>
          <div class="row">
            <div class="col-4 noPaddingLeft">
              <mat-form-field class="full-width">
                <mat-label>Código de área</mat-label>
                <input
                  matInput
                  formControlName="cod_area"
                  autocomplete="off" />
                <mat-error *ngIf="registerPersonForm.controls['cod_area'].errors?.required"
                  >Campo requerido</mat-error
                >
                <mat-error *ngIf="registerPersonForm.controls['cod_area'].errors?.pattern"
                  >Sólo números</mat-error
                >
                <mat-error *ngIf="registerPersonForm.controls['cod_area'].errors?.maxlength"
                  >Máximo 5 números</mat-error
                >
              </mat-form-field>
            </div>
            <div class="col-8 noPaddingRight">
              <mat-form-field class="full-width">
                <mat-label>Número de teléfono</mat-label>
                <input
                  matInput
                  formControlName="telefono"
                  autocomplete="off" />
                <mat-error *ngIf="registerPersonForm.controls['telefono'].errors?.required"
                  >Campo requerido</mat-error
                >
                <mat-error *ngIf="registerPersonForm.controls['telefono'].errors?.pattern"
                  >Sólo números</mat-error
                >
                <mat-error *ngIf="registerPersonForm.controls['telefono'].errors?.maxlength"
                  >Máximo 10 números</mat-error
                >
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6 noPaddingLeft">
          <mat-form-field class="full-width">
            <mat-label>Contraseña</mat-label>
            <input
              matInput
              formControlName="password"
              [type]="hide1 ? 'password' : 'text'" />
            <button
              mat-icon-button
              matSuffix
              class="boton_hide"
              (click)="hide1 = !hide1"
              [attr.aria-label]="'Hide password'"
              [attr.aria-pressed]="hide1">
              <mat-icon>{{ hide1 ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
            <mat-error *ngIf="registerPersonForm.controls['password'].errors?.required"
              >Campo requerido</mat-error
            >
            <mat-error *ngIf="registerPersonForm.controls['password'].errors?.pattern"
              >La contraseña debe tener minimo 8 caracteres, una mayúscula, una minúscula y un
              número
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-12 col-md-6 noPaddingRight">
          <mat-form-field class="full-width">
            <mat-label>Repetir contraseña.</mat-label>
            <input
              matInput
              formControlName="passwordRep"
              [type]="hide ? 'password' : 'text'" />
            <button
              mat-icon-button
              matSuffix
              class="boton_hide"
              (click)="hide = !hide"
              [attr.aria-label]="'Hide password'"
              [attr.aria-pressed]="hide">
              <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
            <mat-error *ngIf="registerPersonForm.controls['passwordRep'].errors?.required"
              >Campo requerido</mat-error
            >
            <mat-error
              *ngIf="registerPersonForm.controls['passwordRep'].hasError('NoPassswordMatch')"
              >Las contraseñas no coinciden</mat-error
            >
          </mat-form-field>
        </div>
      </div>
      <re-captcha
        #captchaRef="reCaptcha"
        (resolved)="registerUser($event)"
        [siteKey]="recaptchaGoogle"
        size="invisible">
      </re-captcha>
      <br />
      <button
        mat-raised-button
        color="primary"
        [disabled]="registerPersonForm.invalid"
        (click)="captchaRef.execute()">
        Registrarme
      </button>
    </form>

    <p class="center">
      ¿Ya tenés cuenta? Inicia sesión
      <a
        class="pointer vinculo"
        (click)="goToLogin()"
        >aca</a
      >
    </p>
  </div>
</div>
